import { createModuleBuilder } from '@evidentid/dashboard-commons/app';
import { GatewayApiClient } from '@evidentid/gateway-api-client';

import AddNoteProcedure from '@/modules/entity-notes/procedures/AddNoteProcedure.vue';
import ViewEntityNoteProcedure from '@/modules/entity-notes/procedures/ViewEntityNoteProcedure.vue';
import ViewNoteProcedure from '@/modules/entity-notes/procedures/ViewNoteProcedure.vue';

export const entityNotesModule = createModuleBuilder()
    .demandContext<{
    gatewayClient: GatewayApiClient;
}>()
    .injectVue((app) => ({
        $gatewayClient: app.gatewayClient,
    }))
    .registerProcedures<{
    addNoteProcedure: { rpName: string, entityId: string, entityDisplayName: string };
    viewEntityNoteProcedure: { rpName: string, entityId: string, noteId: string, initialTags?: string[] };
    viewNoteProcedure: { noteText: string | null, addedBy: string, date: string };
}>({
        addNoteProcedure: AddNoteProcedure,
        viewEntityNoteProcedure: ViewEntityNoteProcedure,
        viewNoteProcedure: ViewNoteProcedure,
    })
    .end();
